import React from 'react';
import { motion } from 'framer-motion';
import cyrenzaLogo from '@/assets/cyrenza-logo.svg';

interface AuthLayoutProps {
  title: string;
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ title, children }) => {
  return (
    <div className="min-h-screen bg-background">
      {/* Simple Header with Logo Only */}
      <header className="sticky top-0 z-50 w-full bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.25, ease: 'easeOut' }}
              className="flex items-center"
            >
              <img 
                src={cyrenzaLogo} 
                alt="Cyrenza Admin" 
                className="h-12 w-12"
              />
            </motion.div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
        <div className="max-w-5xl mx-auto">
          {/* Page Header */}
          <div className="mb-8">
            <h1 className="text-4xl lg:text-5xl font-normal text-black mb-2 tracking-tighter">
              {title}
            </h1>
          </div>

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <div className="text-gray-800 leading-relaxed tracking-tight space-y-6">
              {children}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
